<template>
  <div class="subTitleContainer">
    <div class="subTitle">GI SYMPTOMS</div>
    <div class="assessmentHint">
      Have you been experiencing any of the following symptoms
      <b
        >0 = None&nbsp; &nbsp; 1 = Mild&nbsp; &nbsp; 2 = Moderate&nbsp; &nbsp; 3
        = Severe</b
      >
    </div>
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Abdominal pain"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.abdominal_pain"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.abdominal_pain', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Bad breath"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.bad_breath"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.bad_breath', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Bloating"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.bloating"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.bloating', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Diarrhea"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.diarrhea"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.diarrhea', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Constipation"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.constipation"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.constipation', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Nausea"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.nausea"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.nausea', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Vomiting"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.vomiting"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.vomiting', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Acid reflux or heartburn"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.acid_reflux"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.acid_reflux', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Indigestion"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.indigestion"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.indigestion', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Flatulence (gas)"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.flatulence"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.flatulence', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Greasy / oily appearing stools"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.greasy_stools"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.greasy_stools', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Mucous in stool"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.mucous_in_stool"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.mucous_in_stool', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Change in stool form (harder or softer than usual)"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.change_in_stool"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.change_in_stool', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Blood in stool"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.blood_in_stool"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.blood_in_stool', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Anal fissures (skin tears in anus, hemorrhoids)"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.gi_symptoms.anal_fissures"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('gi_symptoms.anal_fissures', $event)"
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">SYSTEMIC SYMPTOMS</div>
    <div class="assessmentHint">
      Have you been experiencing any of the following symptoms
      <b
        >0 = None/Rarely&nbsp; &nbsp; 1 = Mild/Sometimes&nbsp; &nbsp; 2 = Moderate/Often&nbsp; &nbsp; 3
        = Severe/Always</b
      >
    </div>
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Frequent infections"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.systemic_symptoms.frequent_infections"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('systemic_symptoms.frequent_infections', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Altered weight (sudden loss/gain)"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.systemic_symptoms.altered_weight"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('systemic_symptoms.altered_weight', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Fatigue"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.systemic_symptoms.fatigue"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('systemic_symptoms.fatigue', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Over-eating"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.systemic_symptoms.over_eating"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('systemic_symptoms.over_eating', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Loss of appetite"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.systemic_symptoms.loss_of_appetite"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('systemic_symptoms.loss_of_appetite', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Joint pain"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.systemic_symptoms.joint_pain"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('systemic_symptoms.joint_pain', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Skin concerns: acne/rosacea/rashes"
      width="auto"
      mobileWidth="77.5px"
      :options="severityOptions"
      :value="this.gutZoomerQnr.systemic_symptoms.skin_concerns"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('systemic_symptoms.skin_concerns', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Brain fog"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.systemic_symptoms.brain_fog"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('systemic_symptoms.brain_fog', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Sleep disturbances"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.systemic_symptoms.sleep_disturbances"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('systemic_symptoms.sleep_disturbances', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Fever or night sweats"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.systemic_symptoms.fever"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('systemic_symptoms.fever', $event)"
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">DIETARY PATTERNS</div>
    <div class="assessmentHint">
      How often do you consume the following?
      <b
        >0 = Rarely&nbsp; &nbsp; 1 = Sometimes&nbsp; &nbsp; 2 = Often&nbsp; &nbsp; 3
        = Always</b
      >
    </div>
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="High-fat foods (e.g., avocados, beef, pork, lamb)"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.dietary_patterns.high_fat_foods"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('dietary_patterns.high_fat_foods', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Dairy products (e.g., animal milk, cheese, butter)"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.dietary_patterns.dairy_products"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('dietary_patterns.dairy_products', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Fermented foods (e.g., yogurt, kimchi)"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.dietary_patterns.fermented_foods"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('dietary_patterns.fermented_foods', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Fiber-rich foods (fruits, vegetables, whole grains)"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.dietary_patterns.fiber_rich_foods"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('dietary_patterns.fiber_rich_foods', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Processed foods (e.g., fast food, packaged snacks)"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.dietary_patterns.processed_foods"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('dietary_patterns.processed_foods', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Sugary foods/drinks (e.g., soda, candy)"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.dietary_patterns.sugary_foods"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('dietary_patterns.sugary_foods', $event)"
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Gluten-containing foods (e.g., bread, pasta)"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.dietary_patterns.gluten_containing_foods"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('dietary_patterns.gluten_containing_foods', $event)
      "
    />
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Artificial sweeteners (e.g., diet soda, sugar-free gum)"
      width="auto"
      mobileWidth="77.5px"
      :options="frequencyOptions"
      :value="this.gutZoomerQnr.dietary_patterns.artificial_sweeteners"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('dietary_patterns.artificial_sweeteners', $event)
      "
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">DIGESTIVE FUNCTION</div>
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireRadio
      content="How often do you have bowel movements?"
      width="fit-content"
      mobileWidth="fit-content"
      :options="bowelMovementOptions"
      :value="this.gutZoomerQnr.digestive_function.bowel_movement_frequency"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('digestive_function.bowel_movement_frequency', $event)
      "
    />
  </div>
  <div class="subpartContainer col-container">
    <RadioWithImage
      content="<div class='font-bold'> How would you describe your stool consistency? <span class='font-normal'>(Check the one that applies)</span></div>"
      width="200px"
      mobileWidth="167px"
      :options="stoolOptions"
      :value="this.gutZoomerQnr.digestive_function.stool_consistency"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('digestive_function.stool_consistency', $event)
      "
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">HEALTH CONCERNS</div>
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireMultiChoice
      content="Have you been diagnosed with any of the following conditions?"
      width="fit-content"
      mobileWidth="fit-content"
      :options="gutRelatedConditionOptions"
      :value="this.personalHistoryArray"
      :disabled="this.qnrIsCompleted"
      @onChange="handlePersonHistoryChange"
    />
  </div>
  <div
    class="expandedContainer"
    v-if="this.personalHistoryArray.includes('other')"
  >
    <div class="mb-[10px]">Please specify</div>
    <el-input
      v-model="
        this.gutZoomerQnr.health_concerns.personal_history
          .other_personal_conditions
      "
      class="expandInputField"
      :type="this.dynamic_input_type"
      :disabled="this.qnrIsCompleted"
      @input="
        handleValueChange(
          'health_concerns.personal_history.other_personal_conditions',
          $event
        )
      "
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireMultiChoice
      content="Family History of any of the following conditions"
      width="fit-content"
      mobileWidth="fit-content"
      :options="gutRelatedFamilyHistoryOptions"
      :value="this.familyHistoryArray"
      :disabled="this.qnrIsCompleted"
      @onChange="handleFamilyHistoryChange"
    />
  </div>
  <div
    class="expandedContainer"
    v-if="this.familyHistoryArray.includes('other')"
  >
    <div class="mb-[10px]">Please specify</div>
    <el-input
      v-model="
        this.gutZoomerQnr.health_concerns.family_history.other_family_conditions
      "
      class="expandInputField"
      :type="this.dynamic_input_type"
      :disabled="this.qnrIsCompleted"
      @input="
        handleValueChange(
          'health_concerns.family_history.other_family_conditions',
          $event
        )
      "
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">MEDICATION HISTORY</div>
  </div>
  <div class="subpartContainer">
    <QuestionnaireRadio
      content="Have you taken antibiotics in the past 2 months?"
      width="132px"
      mobileWidth="163px"
      :options="yesNoOptions"
      :value="this.gutZoomerQnr.medication_history.antibiotics"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('medication_history.antibiotics', $event)"
    />
  </div>
  <div
    class="subpartContainer col-container"
    v-if="this.gutZoomerQnr.medication_history.antibiotics"
  >
    <QuestionnaireRadio
      content="<div class='font-normal'>if Yes,</div>"
      width="fit-content"
      :options="antibioticsHistoryOptions"
      :value="this.gutZoomerQnr.medication_history.antibiotics_history"
      :disabled="this.qnrIsCompleted"
      @onChange="
        handleValueChange('medication_history.antibiotics_history', $event)
      "
    />
  </div>
  <div class="pl-[16px]">
    <div class="title">Are you currently on any medications?</div>
  </div>
  <div class="expandedContainer">
    <div class="mb-[10px]">Please specify</div>
    <el-input
      v-model="this.gutZoomerQnr.medication_history.current_medications"
      class="expandInputField"
      :type="this.dynamic_input_type"
      :disabled="this.qnrIsCompleted"
      @input="
        handleValueChange('medication_history.current_medications', $event)
      "
    />
  </div>
  <div class="subTitleContainer">
    <div class="subTitle">LIFESTYLE</div>
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireRadio
      content="How active are you?"
      width="fit-content"
      :options="activeOptions"
      :value="this.gutZoomerQnr.lifestyle.active_level"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('lifestyle.active_level', $event)"
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireRadio
      content="How many hours of sleep do you get on average per night?"
      width="fit-content"
      :options="sleepHoursOptions"
      :value="this.gutZoomerQnr.lifestyle.sleep_hours"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('lifestyle.sleep_hours', $event)"
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireRadio
      content="Do you use tobacco or nicotine products?"
      width="fit-content"
      :options="tabaccoUseOptions"
      :value="this.gutZoomerQnr.lifestyle.nicotine_use"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('lifestyle.nicotine_use', $event)"
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireRadio
      content="How often do you have a drink(s) containing alcohol?"
      width="fit-content"
      :options="alcoholUseOptions"
      :value="this.gutZoomerQnr.lifestyle.alcohol_use"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('lifestyle.alcohol_use', $event)"
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireRadio
      content="How would you rate your stress levels"
      width="fit-content"
      :options="stressLevelOptions"
      :value="this.gutZoomerQnr.lifestyle.stress_level"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('lifestyle.stress_level', $event)"
    />
  </div>
  <div class="subpartContainer col-container">
    <QuestionnaireRadio
      content="How often do you engage in any stress-reducing techniques (such as mindfulness, breathing exercises, yoga, prayer, or other relaxation practices)?"
      width="fit-content"
      :options="stressReductionOptions"
      :value="this.gutZoomerQnr.lifestyle.stress_reduction"
      :disabled="this.qnrIsCompleted"
      @onChange="handleValueChange('lifestyle.stress_reduction', $event)"
    />
  </div>
</template>

<script>
import QuestionnaireRadio from "./QuestionnaireRadio.vue";
import QuestionnaireMultiChoice from "./QuestionnaireMultiChoice.vue";
import RadioWithImage from "./RadioWithImage.vue";
import { useGutZoomerStore } from "@/stores/GutZoomerStore.ts";
import { mapState, mapActions } from "pinia";
import { useWindowSize } from "@vueuse/core";

import {
  yesNoOptions,
  severityOptions,
  frequencyOptions,
  activeOptions,
  sleepHoursOptions,
  tabaccoUseOptions,
  alcoholUseOptions,
  stressLevelOptions,
  stressReductionOptions,
  antibioticsHistoryOptions,
  gutRelatedConditionOptions,
  gutRelatedFamilyHistoryOptions,
  bowelMovementOptions,
  stoolOptions,
} from "@/utils/questionnaireOptions";

export default {
  name: "GutRelatedQuestions",
  components: {
    QuestionnaireRadio,
    QuestionnaireMultiChoice,
    RadioWithImage,
  },
  props: {
    showWarning: Boolean,
  },
  data() {
    return {
      lastMenstrualPeriod: "",
      yesNoOptions,
      severityOptions,
      frequencyOptions,
      activeOptions,
      sleepHoursOptions,
      tabaccoUseOptions,
      alcoholUseOptions,
      stressLevelOptions,
      stressReductionOptions,
      antibioticsHistoryOptions,
      gutRelatedConditionOptions,
      gutRelatedFamilyHistoryOptions,
      bowelMovementOptions,
      stoolOptions,
    };
  },
  mounted() {
    this.lastMenstrualPeriod = this.lastMenstrualDate;
  },
  setup() {
    const { width } = useWindowSize();
    return {
      width,
    };
  },
  watch: {
    antibioticsChoice: {
      immediate: true,
      handler: function (newValue) {
        if (!newValue) {
          this.handleValueChange(
            "medication_history.antibiotics_history",
            null
          );
        }
      },
    },
  },
  computed: {
    ...mapState(
      () => useGutZoomerStore(),
      [
        "gutZoomerQnr",
        "personalHistoryArray",
        "familyHistoryArray",
        "qnrIsCompleted",
      ]
    ),
    isMobile() {
      return this.width <= 808;
    },
    dynamic_input_type() {
      return this.isMobile ? "textarea" : "text";
    },
    antibioticsChoice() {
      return this.gutZoomerQnr.medication_history.antibiotics;
    },
  },
  methods: {
    ...mapActions(
      () => useGutZoomerStore(),
      [
        "getZoomerQnrData",
        "submitGutZoomerQnr",
        "setGutZoomerQnrSingleField",
        "setPersonalHistoryArray",
        "setFamilyHistoryArray",
        "convertGutZoomerQnrArrayToObject",
      ]
    ),
    handleValueChange(key, value) {
      this.setGutZoomerQnrSingleField(key, value);
      if (
        key === "basic_info.reproductive_health_stage" ||
        key === "basic_info.current_menstrual_phase"
      ) {
        this.$emit("removeWarning");
      }
    },
    handlePersonHistoryChange(value) {
      console.log("handlePersonHistoryChange", value);
      this.setPersonalHistoryArray(value);
      //convert array value to boolean
      this.convertGutZoomerQnrArrayToObject("personal_history", value);
    },
    handleFamilyHistoryChange(value) {
      console.log("handleFamilyHistoryChange", value);
      this.setFamilyHistoryArray(value);
      // convert array value to boolean
      this.convertGutZoomerQnrArrayToObject("family_history", value);
    },
  },
};
</script>

<style scoped>
.subpartContainer {
  width: 100%;
  padding: 0px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.col-container {
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
}

.title {
  font-weight: 600;
}

.inputField {
  height: 42px;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.4px;
  color: #000000;
  border-radius: 4px;
  width: 593px;
}

.expandInputField {
  height: 42px;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.4px;
  color: #000000;
  border-radius: 4px;
  width: 760px;
}

:deep(.el-textarea__inner) {
  caret-color: #000 !important;
  white-space: normal;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.4px;
  color: #000000;
  resize: none;
  height: 126px;
  box-shadow: none;
  padding: 12px 16px;
  border: 1px solid #bcccdc;
}

:deep(.el-input__wrapper) {
  box-shadow: none;
  border: 1px solid #bcccdc;
  padding-left: 21px;
}

.subTitleContainer {
  padding: 12px 24px;
  border-radius: 4px;
  background-color: #faece6;
  margin-top: 36px;
  margin-bottom: 24px;
}

.subTitle {
  color: #0e4672;
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0.17px;
}

.assessmentHint {
  font-family: Roboto;
  font-size: 16px;
  margin-top: 8px;
}

.assessmentHint b {
  font-weight: 700;
  font-style: italic;
  display: block;
}

.expandedContainer {
  padding: 12px 24px;
  border-radius: 4px;
  background-color: #f3f6f8;
  margin: 12px 12px;
}

:deep(.el-input__inner) {
  color: #000000;
}

:deep(.el-input.is-disabled .el-input__wrapper) {
  background-color: #f2f2f2;
}

:deep(.el-input.is-disabled .el-input__inner) {
  -webkit-text-fill-color: #1c1c1c;
}

:deep(.el-textarea.is-disabled .el-textarea__inner) {
  background-color: #f2f2f2;
  -webkit-text-fill-color: #1c1c1c;
}

@media only screen and (max-width: 808px) {
  .subpartContainer {
    width: 100%;
    padding: 0px 8px;
    margin-bottom: 12px;
    flex-direction: column;
    align-items: flex-start;
  }

  .inputField {
    width: 334px;
    height: 42px;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0.4px;
  }

  .subpartContainer .title {
    font-size: 14px;
  }

  .subTitleContainer {
    padding: 12px 16px;
    margin-top: 24px;
    margin-bottom: 12px;
  }

  .subTitle {
    font-size: 14px;
    line-height: 16px;
  }

  .expandedContainer {
    padding: 12px 16px;
    margin: 12px 8px;
    font-size: 14px;
  }

  .assessmentHint {
    font-size: 14px;
    line-height: 14px;
  }

  .assessmentHint b {
    margin-top: 8px;
    display: block;
  }

  :deep(.el-textarea__inner) {
    font-size: 14px;
    line-height: 16px;
  }

  .expandInputField {
    height: 100px;
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0.4px;
    color: #000000;
    border-radius: 4px;
    width: 310px;
  }

  .expandedContainer :deep(.el-textarea__inner) {
    height: 100px;
  }
}
</style>
